import { validateEmail, validateName } from '@/lib/validate';
import * as yup from 'yup';

export interface ProfileFormValues {
  name: string;
  email: string;
}

/** Yup schema mirroring {@link validateName} and {@link validateEmail} (same rules as signup name/email). */
export function createProfileSchema(t: (key: string) => string) {
  return yup.object({
    name: yup
      .string()
      .required(() => t('signup_required_name'))
      .test('name', function (value) {
        const result = validateName(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
    email: yup
      .string()
      .required(() => t('signup_required_email'))
      .test('email', function (value) {
        const result = validateEmail(value ?? '');
        if (result === true) return true;
        return this.createError({ message: result });
      }),
  });
}
